import { useEffect } from 'react';
import Layout from '../../../components/layout/Layout';
import Breadcrumb from '../../../components/layout/Breadcrumb';
import { updateSEO } from '../../../utils/seo';
import CurriculumDesc from '../../../components/qualifications/CurriculumDesc';

// ===== Associate Butler 詳細ページ 全面最新化（Implementer B スコープ） =====
// デザイン土台（型正典）: src/pages/about/overview/page.tsx / src/pages/home/page.tsx の新スタイル
//   （紺#1a2942 / 真鍮金#a38e65 / 金差し色#d7b779 / BTN-08 2状態 / 金eyebrow→金差し色見出し→真鍮短罫 /
//    リード3行+ / 細罫エディトリアル行 / 装飾ディバイダー禁止）。
// 事実正典（創作禁止・実データ変更禁止・出典path記録）:
//   [S-cur] 旧 src/pages/qualifications/associate-butler/page.tsx（カリキュラム全10章・料金・試験要項の実データ）
//   [S-canon] mng-thebutler/00_事業説明.md L22-27,L34-40,L63（理念・三段階資格・お台場サロン）
//   [S-overview] src/pages/about/overview/page.tsx（BTN08・セクション文法・facts）
// ここに無い数値・事実は書かない。料金48,000円等は実データのまま。

const BTN08_ON_NAVY = "relative inline-flex items-center justify-center bg-[#a38e65] text-white font-semibold border border-[#1a2942] px-[42px] py-[16px] text-sm tracking-[0.2em] font-['Noto_Serif_JP',serif] transition-colors duration-300 hover:bg-[#1a2942] hover:text-[#f8f6f0] hover:border-[#a38e65] cursor-pointer whitespace-nowrap before:content-[''] before:absolute before:inset-1 before:border before:border-[#1a2942]/40 before:pointer-events-none before:transition-colors before:duration-300 hover:before:border-[#a38e65]/50";

// [S-cur] カリキュラム全10章（実データ・文言不変）
const curriculum = [
  { n: '01', t: '執事の歴史と文化', d: '執事という職業の起源から現代に至るまでの発展の歴史を学びます。ヨーロッパの貴族社会で生まれた執事の役割、世界各国の執事文化の違い、日本における執事の位置づけなどを理解し、執事が大切にしてきた価値観の本質に触れます。歴史を知ることで、なぜ執事が品格と信頼の象徴とされてきたのかが理解できます。' },
  { n: '02', t: '執事の心得と哲学', d: 'ホスピタリティとは何か、おもてなしの心とはどのようなものかを深く学びます。相手の立場に立った配慮、先回りした気配り、見えない部分での準備など、執事が大切にする価値観とプロフェッショナルとしての姿勢を習得します。この章は資格全体の根幹となる重要な内容です。' },
  { n: '03', t: '基本マナーとエチケット', d: '社会生活の基本となるマナーを執事の視点から学びます。正しい立ち居振る舞い、お辞儀の種類と使い分け、敬語と丁寧な言葉遣い、公共の場でのエチケットなど、品格ある振る舞いの基礎を身につけます。礼は深さで三段階に分け、場面ごとの使い分けを練習します。会釈（約十五度）はいちばん軽い礼で、視線をわずかに落としながら頭を軽く下げる程度。廊下ですれ違うときや軽い挨拶など、日常のさりげない場面向きです。普通礼（約三十度）は玄関でのお迎え・お見送りや主人・お客様へのご挨拶など、執事の日常業務で最も回数の多い礼です。\n\n敬礼（約四十五度）は三つのうち最も深い礼で、心からのお詫び、深い感謝、特別なお客様のお迎えなど、強い敬意や誠意を表す場面で使います。\n\n順番は「語先後礼」。まず言葉を伝え、そのあとで礼に移るのが丁寧な作法です。頭を下げた姿勢のまま口を開くと、声が床に向かってこもり、せっかくの言葉が相手に届きにくくなります。\n\n普通礼と敬礼では、背中を伸ばしたまま腰から折り、いちばん低い位置で一呼吸置いてから、ゆっくり元の姿勢へ戻ります。起き上がりを急ぐと礼そのものが軽く見えてしまうため、協会では戻る動きにも下げるときと同じだけの時間をかけるよう勧めています。日常生活でもすぐに実践できる内容です。' },
  { n: '04', t: '身だしなみと印象管理', d: '第一印象の重要性を理解し、適切な服装選びや清潔感の保ち方を学びます。TPOに応じた装い、髪型や爪の手入れ、香りへの配慮など、細部にまで気を配る執事の美意識を習得します。外見から伝わる誠実さと信頼感の作り方を実践的に学びます。' },
  { n: '05', t: 'コミュニケーション基礎', d: '相手に好印象を与えるコミュニケーション技術を学びます。傾聴の技術、適切な距離感の保ち方、非言語コミュニケーション（表情・姿勢・視線）の重要性、報告・連絡・相談の基本など、円滑な人間関係を築くための基礎を習得します。' },
  { n: '06', t: 'テーブルマナーの基礎', d: '食事の場での正しいマナーを学びます。洋食のテーブルマナー、和食のマナー、カトラリーとグラスの正しい使い方、食事中の美しい振る舞いなど、フォーマルな場面でも自信を持って対応できる知識を身につけます。' },
  { n: '07', t: '基本的な接客応対', d: '来客対応、電話応対、案内と誘導、お見送りの作法など、接客の基本を執事の視点から学びます。相手を心地よくする言葉選び、スマートな動作、細やかな配慮など、プロフェッショナルな接客技術の基礎を習得します。' },
  { n: '08', t: '日常の気配り', d: '環境整備の基本、整理整頓の考え方、季節に応じた配慮、観察力の磨き方など、日常生活での気配りの技術を学びます。小さな変化に気づく力、快適な環境を維持する方法など、執事の「見えない仕事」の本質を理解します。' },
  { n: '09', t: '冠婚葬祭のマナー', d: '結婚式、葬儀、お祝い事、贈答など、人生の重要な場面でのマナーを学びます。それぞれの場面で求められる振る舞い、適切な服装、贈り物の選び方など、社会人として知っておくべき冠婚葬祭のエチケットを習得します。' },
  { n: '10', t: '総合演習', d: 'これまで学んだ内容を実践的なケーススタディで確認します。場面別の対応シミュレーション、総合的な復習問題などを通じて、学んだ知識を確実に定着させます。試験対策としても重要な章です。' },
];

const recommended = [
  'サービス業でスキルアップを目指している方',
  '接客や営業の仕事で品格ある振る舞いを身につけたい方',
  '冠婚葬祭などで正しいマナーを学びたい方',
  'ビジネスシーンでの振る舞いを向上させたい方',
  '執事という職業に興味がある方',
  '自己研鑽として教養を深めたい方',
  '日常生活でのホスピタリティ意識を高めたい方',
  '将来、Professional Butler や Master Butler を目指したい方',
];

const materials = [
  { t: 'テキスト教材（約100ページ）', d: '執事の基礎を丁寧に解説した専用テキスト。イラストや図解も豊富で、初めての方でも理解しやすい構成です。' },
  { t: 'オンライン動画レッスン', d: '実技を含む分かりやすい動画解説。お辞儀の仕方、テーブルマナーの実践など、動画だからこそ分かる内容が満載です。視聴期間は1年間。' },
  { t: '実技練習用キット', d: '学習をサポートする練習用グッズをセットでお届けします。自宅でも実技練習を進められます。' },
  { t: '認定試験問題・解答用紙', d: '自宅で取り組める試験問題。じっくり考えて解答できます。返送後、当協会が添削・採点します。' },
];

const examRows = [
  ['試験形式', '筆記試験（記述式・選択式の混合）'],
  ['合格基準', '80点以上'],
  ['試験期限', '申込から1年以内に提出'],
  ['受験資格', '制限なし（どなたでも受験可能）'],
  ['受験場所', '自宅（通信試験）'],
  ['再試験', '不合格の場合、再試験料15,000円で何度でも再挑戦可能'],
];

// 三段階の階梯（Associate→Professional→Master）。現在地=associate
const ladder = [
  { key: 'associate', roman: 'I', name: 'Associate Butler', ja: 'アソシエイト・バトラー', price: '48,000', level: '初級', href: '/qualifications/associate-butler' },
  { key: 'professional', roman: 'II', name: 'Professional Butler', ja: 'プロフェッショナル・バトラー', price: '78,000', level: '中級', href: '/qualifications/professional-butler' },
  { key: 'master', roman: 'III', name: 'Master Butler', ja: 'マスター・バトラー', price: '128,000', level: '上級', href: '/qualifications/master-butler' },
];

function SecHead({ roman, en, children }: { roman: string; en: string; children: React.ReactNode }) {
  return (
    <div className="mb-9">
      <div className="-mx-5 sm:-mx-8 mb-6 bg-[#1a2942] border-y border-[#a38e65]/25 px-5 sm:px-8 py-[18px]">
        <span className="block font-['Playfair_Display',serif] uppercase tracking-[0.28em] text-xs text-[#d7b779]">{roman}. {en}</span>
      </div>
      <h2 className="jba-display font-medium text-[#1a2942] text-2xl sm:text-3xl lg:text-[31px] leading-[1.5] tracking-[0.02em]">{children}</h2>
    </div>
  );
}

export default function AssociateButlerPage() {
  useEffect(() => {
    updateSEO({
      title: 'Associate Butler（アソシエイト・バトラー）｜執事の基礎を学ぶ初級資格 | 全日本執事協会',
      description: '全日本執事協会認定 Associate Butler は、執事の基礎知識とマナーを体系的に学ぶ初級資格です。未経験からでも自宅学習で2〜4ヶ月、料金48,000円。執事サロン3時間無料体験（30,000円相当）付き。全10章のカリキュラムと通信試験で確かな第一歩を。',
      keywords: 'Associate Butler,アソシエイト・バトラー,執事資格,初級資格,執事検定,マナー,全日本執事協会',
      canonical: 'https://butler-association.jp/qualifications/associate-butler',
    });
  }, []);

  const breadcrumbs = [
    { label: 'ホーム', href: '/' },
    { label: '執事資格制度', href: '/qualifications' },
    { label: 'Associate Butler' },
  ];

  return (
    <Layout>
      {/* ===== ヒーロー：全幅ビルボード（画像+紺オーバーレイ+左寄せ）。由来: overview ヒーロー文法 ===== */}
      <section className="relative bg-[#1a2942] overflow-hidden min-h-[540px] lg:min-h-[620px] flex items-center">
        <img
          src="/images/generated/jba-study-gramophone-02.webp"
          alt="蓄音機と古書の学びの机"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(16,20,26,0.93)_0%,rgba(16,20,26,0.74)_48%,rgba(16,20,26,0.36)_100%)]"></div>
        <div className="relative z-10 w-full max-w-[1200px] mx-auto px-5 sm:px-8 pt-32 pb-16 lg:pt-36 lg:pb-20">
          <div className="max-w-[680px]">
            <span className="block font-['Playfair_Display',serif] uppercase tracking-[0.32em] text-xs sm:text-[13px] text-[#d7b779] mb-4">Associate Butler ・ Level I</span>
            <div className="w-12 h-px bg-[#a38e65] mb-6"></div>
            <h1 className="jba-display font-normal text-white text-[clamp(28px,3.4vw,44px)] leading-[1.4] tracking-[0.04em] mb-3">
              執事への第一歩、<span className="text-[#d7b779]">Associate Butler</span>
            </h1>
            <p className="font-['Noto_Serif_JP',serif] text-[#e7e2d8] text-sm tracking-[0.14em] mb-6">アソシエイト・バトラー ／ 初級資格</p>
            <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-white/90 leading-[1.95] mb-8">
              執事の基礎知識と教養を体系的に身につける入門資格です。ホスピタリティの本質、正しいマナー、おもてなしの心を執事の視点から学びます。未経験のかたでも安心して挑戦でき、接客業・冠婚葬祭・ビジネスなど、暮らしと仕事の幅広い場面で活きる教養が身につきます。
            </p>
            <div className="flex flex-wrap items-end gap-x-8 gap-y-3">
              <div>
                <span className="block font-['Playfair_Display',serif] uppercase tracking-[0.2em] text-[10px] text-[#d7b779] mb-1">Fee</span>
                <span className="jba-display text-white text-[26px] sm:text-[28px] leading-none">48,000<span className="text-base text-[#d7b779] ml-1">円</span></span>
                <span className="block font-['Noto_Serif_JP',serif] text-[11px] text-white/60 mt-1">税込・送料込</span>
              </div>
              <a href="/contact" className={BTN08_ON_NAVY}>受講を申し込む</a>
            </div>
          </div>
        </div>
      </section>

      {/* パンくず: ビルボード直後に配置（Yuichi 2026-07-17 指摘②）。共通Breadcrumbのヘッダー逃げpaddingを子セレクタで通常paddingへ上書き */}
      <div className="bg-white [&>div]:!pt-6">
        <Breadcrumb items={breadcrumbs} />
      </div>

      <div className="bg-white">
        <div className="max-w-[1200px] mx-auto px-5 sm:px-8 py-14 sm:py-18 lg:py-20 space-y-16 sm:space-y-20">

          {/* --- I. 概要リード（金eyebrow+金差し色見出し+リード+細罫データ行）。由来: overview S1 --- */}
          <section>
            <SecHead roman="I" en="About This Certification">執事の基礎を、<span className="text-[#a38e65]">体系立てて</span>身につける</SecHead>
            <div className="space-y-[18px] font-['Noto_Serif_JP',serif] text-base text-[#333] leading-[1.95] max-w-3xl">
              <p>Associate Butler 資格は、執事という職業の基礎を学ぶことを通じて、品格ある振る舞いやホスピタリティの本質を理解する資格です。執事の歴史や役割から始まり、日常生活やサービス業で活かせる実践的なマナー、コミュニケーション技術、おもてなしの心を体系的に学びます。</p>
              <p>未経験のかたでも安心して学習できる内容で、自宅でご自身のペースで学習を進められます。テキスト教材とオンライン動画レッスンを組み合わせた学習方法により、2〜4ヶ月程度で試験に挑戦できる力が身につきます。</p>
              <p>執事としての基礎を固めたいかたはもちろん、接客業でのスキルアップ、冠婚葬祭でのマナー習得、ビジネスシーンでの品格ある振る舞いを目指すかたにも最適な、はじめの一歩となる資格です。</p>
            </div>
            {/* 細罫データ行（料金は大字serif強調） */}
            <dl className="grid grid-cols-2 md:grid-cols-4 gap-y-6 gap-x-4 mt-10 border-t border-[#e2ddd2] pt-8">
              <div>
                <dt className="font-['Noto_Serif_JP',serif] text-xs text-[#8f7a56] tracking-[0.06em] mb-1.5">料金</dt>
                <dd className="jba-display text-[#1a2942] text-[26px] leading-none">48,000<span className="text-sm text-[#8f7a56] ml-1">円</span></dd>
              </div>
              <div>
                <dt className="font-['Noto_Serif_JP',serif] text-xs text-[#8f7a56] tracking-[0.06em] mb-1.5">テキスト</dt>
                <dd className="font-['Playfair_Display',serif] text-2xl text-[#1a2942]">約100<span className="text-sm text-[#8f7a56] ml-1">頁</span></dd>
              </div>
              <div>
                <dt className="font-['Noto_Serif_JP',serif] text-xs text-[#8f7a56] tracking-[0.06em] mb-1.5">学習期間目安</dt>
                <dd className="font-['Playfair_Display',serif] text-2xl text-[#1a2942]">2–4<span className="text-sm text-[#8f7a56] ml-1">ヶ月</span></dd>
              </div>
              <div>
                <dt className="font-['Noto_Serif_JP',serif] text-xs text-[#8f7a56] tracking-[0.06em] mb-1.5">受験資格</dt>
                <dd className="font-['Noto_Serif_JP',serif] text-lg text-[#1a2942] leading-tight pt-1">なし</dd>
              </div>
            </dl>
          </section>

          {/* --- II. この資格の3つの特徴（番号付き2カラムブロック型）。由来: overview S4 事業領域文法を特徴列に応用 --- */}
          <section>
            <SecHead roman="II" en="Why Associate">未経験から、<span className="text-[#a38e65]">無理なく</span>始められる</SecHead>
            <div className="grid md:grid-cols-3 gap-x-10 gap-y-8">
              {[
                { no: '01', en: 'For Beginners', ja: '未経験者歓迎', d: '特別な受験資格は不要です。執事の世界に初めて触れるかたでも、基礎からていねいに学べる構成になっています。' },
                { no: '02', en: 'Learn at Home', ja: '自宅で学べる', d: '通信教育のため、全国どこからでも受講可能。仕事や家庭と両立しながら、ご自身のペースで学習を進められます。' },
                { no: '03', en: 'Practical', ja: '暮らしに活きる', d: '執事の教養は、日常生活やビジネスの場でもそのまま役立ちます。学んだその日から実践できる知識が中心です。' },
              ].map((f) => (
                <div key={f.no} className="border-t border-[#e2ddd2] pt-6">
                  <span className="font-['Playfair_Display',serif] text-[#d7b779] text-3xl leading-none block mb-3">{f.no}</span>
                  <span className="block font-['Playfair_Display',serif] italic text-[#8f7a56] text-[13px] tracking-[0.06em] mb-1">{f.en}</span>
                  <h3 className="jba-display font-medium text-[#1a2942] text-lg sm:text-xl mb-2.5 leading-[1.5]">{f.ja}</h3>
                  <p className="font-['Noto_Serif_JP',serif] text-sm text-[#4a4638] leading-[1.9]">{f.d}</p>
                </div>
              ))}
            </div>
          </section>

          {/* --- III. カリキュラム（番号付きエディトリアル行＋画像）。由来: overview S4 --- */}
          <section>
            <SecHead roman="III" en="Curriculum ・ 10 Chapters">全10章で学ぶ、<span className="text-[#a38e65]">執事の基礎</span></SecHead>
            <p className="font-['Noto_Serif_JP',serif] text-base text-[#333] leading-[1.95] max-w-3xl mb-8">
              Associate Butler では、執事の基礎となる10の分野を体系的に学びます。各章は実践的な内容で構成され、知識だけでなく、実際の振る舞いや技術も身につくよう設計されています。
            </p>
            <img
              src="/images/generated/jba-fs-149-qualifications_associate-butler.webp"
                alt="礼装とトップハットを収めた衣装棚。Associate Butlerで扱う装いの基礎"
              className="w-full aspect-[21/9] h-auto object-cover object-center border border-[#a38e65]/30 mb-10"
            />
            <div className="grid md:grid-cols-2 gap-x-10 gap-y-8">
              {curriculum.map((c) => (
                <div key={c.n} className="flex gap-5 border-t border-[#e2ddd2] pt-6">
                  <span className="font-['Playfair_Display',serif] text-[#d7b779] text-3xl leading-none shrink-0 pt-1">{c.n}</span>
                  <div>
                    <h3 className="jba-display font-medium text-[#1a2942] text-lg mb-2.5 leading-[1.5]">{c.t}</h3>
                    <CurriculumDesc text={c.d} />
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* --- IV. こんなかたに（細罫2カラムリスト型）= 新バリエーション①
               由来注記: overview S2 の定義リスト（dl・上罫+行罫）文法を、チェック項目の2カラム列挙へ翻案。
               トップ・overview に該当リスト型は無いため新造。カード乱立を避けエディトリアルな行組みで提示。 --- */}
          <section>
            <SecHead roman="IV" en="Recommended For">こんなかたに、<span className="text-[#a38e65]">おすすめです</span></SecHead>
            <ul className="grid sm:grid-cols-2 gap-x-10 border-t-2 border-[#1a2942]">
              {recommended.map((r) => (
                <li key={r} className="flex items-start gap-3 border-b border-[#e2ddd2] py-4">
                  <span className="text-[#a38e65] text-[13px] leading-none pt-1.5" aria-hidden="true">◆</span>
                  <span className="font-['Noto_Serif_JP',serif] text-[15px] text-[#1a2942] leading-[1.8]">{r}</span>
                </li>
              ))}
            </ul>
          </section>

          {/* --- V. お届けする教材（積層splitカード型）= 新バリエーション②
               由来注記: デザインカタログ SEC-N04（積層splitカード・画像0.4/テキスト0.6）の文法を採り、
               番号付きの横並びカードで教材を提示。overview には積層カード型が無いため新造。 --- */}
          <section>
            <SecHead roman="V" en="Course Materials">お手元に届く、<span className="text-[#a38e65]">学びの一式</span></SecHead>
            <div className="grid md:grid-cols-2 gap-6">
              {materials.map((m, i) => (
                <div key={m.t} className="flex gap-5 bg-[#f8f6f0] border border-[#a38e65]/25 p-6">
                  <span className="font-['Playfair_Display',serif] text-[#a38e65] text-2xl leading-none shrink-0 pt-0.5">{String(i + 1).padStart(2, '0')}</span>
                  <div>
                    <h3 className="jba-display font-medium text-[#1a2942] text-base sm:text-lg mb-2 leading-[1.5]">{m.t}</h3>
                    <p className="font-['Noto_Serif_JP',serif] text-sm text-[#4a4638] leading-[1.9]">{m.d}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-6 bg-[#1a2942] px-7 sm:px-10 py-7 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-7">
              <span className="font-['Playfair_Display',serif] italic text-[#d7b779] text-sm tracking-[0.06em] shrink-0">Special Bonus</span>
              <div>
                <h3 className="jba-display font-medium text-[#f8f6f0] text-lg mb-1">執事サロン3時間 無料体験チケット</h3>
                <p className="font-['Noto_Serif_JP',serif] text-sm text-[#ded8cc] leading-[1.9]">お台場の執事サロンで、実際の執事サービスを体験できる特別チケット（30,000円相当）。学びをいっそう深められます。</p>
              </div>
            </div>
          </section>

          {/* --- VI. 認定試験について（定義リスト/罫線テーブル型）。由来: overview S2 法人概要の罫線dl文法 --- */}
          <section>
            <SecHead roman="VI" en="Certification Exam">試験は、<span className="text-[#a38e65]">ご自宅で</span>受けられます</SecHead>
            <div className="grid lg:grid-cols-[1fr_320px] gap-8 lg:gap-12 items-start">
              <dl className="border-t-2 border-[#1a2942]">
                {examRows.map(([label, value]) => (
                  <div key={label} className="flex flex-col sm:flex-row gap-1 sm:gap-6 border-b border-[#e2ddd2] py-4">
                    <dt className="sm:w-[110px] sm:shrink-0 font-['Noto_Serif_JP',serif] text-sm text-[#8f7a56] tracking-[0.06em] pt-0.5">{label}</dt>
                    <dd className="flex-1 font-['Noto_Serif_JP',serif] text-[15px] sm:text-base text-[#1a2942] leading-[1.85]">{value}</dd>
                  </div>
                ))}
              </dl>
              <div className="lg:pt-1">
                <img
                  src="/images/generated/jba-p-018-qual-homestudy.webp"
                  alt="通信試験の様子。自宅でじっくり取り組める認定試験"
                  className="w-full h-56 lg:h-[300px] object-cover border border-[#a38e65]/30 mb-4"
                />
                <p className="font-['Noto_Serif_JP',serif] text-sm text-[#4a4638] leading-[1.9]">
                  教材が届いたら、ご自身のペースで学習を進め、準備ができた段階で試験問題に取り組みます。解答用紙を返送いただくと、当協会が添削・採点し、80点以上で合格。認定証と認定カードを発行します。
                </p>
              </div>
            </div>
          </section>

          {/* --- VII. 三段階の階梯（現在地ハイライト・導線）= 新バリエーション③
               由来注記: overview S5 縦タイムラインの「年号→出来事」文法を、資格三段階の「級→資格名+料金」ステップへ翻案。
               飛び級不可の階梯を可視化し、現在地を紺で強調。トップ・overview に資格ステッパー型は無いため新造。 --- */}
          <section>
            <SecHead roman="VII" en="The Three Tiers">資格は、<span className="text-[#a38e65]">三段階</span>で高めていく</SecHead>
            <p className="font-['Noto_Serif_JP',serif] text-base text-[#333] leading-[1.95] max-w-3xl mb-8">
              執事資格は、初級 Associate Butler から、中級 Professional Butler、上級 Master Butler へと、段階的に取得します。飛び級での受験はできません。まずはこの Associate Butler で確かな基礎を固めることが、その先の道を拓きます。
            </p>
            <ol className="border-t border-[#e2ddd2]">
              {ladder.map((t) => {
                const current = t.key === 'associate';
                return (
                  <li key={t.key} className={current ? 'bg-[#1a2942] border-b border-[#e2ddd2]' : 'border-b border-[#e2ddd2]'}>
                    <a href={t.href} className={`flex flex-wrap items-center gap-x-6 gap-y-2 px-5 sm:px-7 py-5 group ${current ? '' : 'hover:bg-[#f8f6f0]'} transition-colors duration-300`}>
                      <span className={`font-['Playfair_Display',serif] text-2xl w-8 shrink-0 ${current ? 'text-[#d7b779]' : 'text-[#a38e65]'}`}>{t.roman}</span>
                      <div className="min-w-[210px]">
                        <span className={`block jba-display text-lg ${current ? 'text-[#f8f6f0]' : 'text-[#1a2942]'}`}>{t.name}{current && <span className="ml-3 align-middle text-[10px] font-['Noto_Serif_JP',serif] tracking-[0.14em] text-[#1a2942] bg-[#d7b779] px-2 py-0.5">現在ご覧のページ</span>}</span>
                        <span className={`block font-['Noto_Serif_JP',serif] text-xs mt-0.5 ${current ? 'text-[#c9c2b4]' : 'text-[#8f7a56]'}`}>{t.ja}・{t.level}</span>
                      </div>
                      <span className={`jba-display text-xl ml-auto ${current ? 'text-[#d7b779]' : 'text-[#1a2942]'}`}>{t.price}<span className={`text-xs ml-1 ${current ? 'text-[#c9c2b4]' : 'text-[#8f7a56]'}`}>円</span></span>
                      <span className={`font-['Noto_Serif_JP',serif] text-sm shrink-0 ${current ? 'text-[#d7b779]' : 'text-[#a38e65] group-hover:translate-x-1 transition-transform'}`}>{current ? '—' : '詳細を見る →'}</span>
                    </a>
                  </li>
                );
              })}
            </ol>
          </section>

          {/* --- VIII. 料金と申込（紺CTAパネル型）。由来: overview S6 締めCTA --- */}
          <section>
            <SecHead roman="VIII" en="Enrollment">受講のご案内</SecHead>
            <div className="bg-[#1a2942] border border-[#a38e65]/45 p-8 sm:p-10 lg:p-12">
              <div className="flex flex-wrap items-end gap-x-8 gap-y-3 mb-8 pb-8 border-b border-white/15">
                <div>
                  <span className="block font-['Playfair_Display',serif] uppercase tracking-[0.2em] text-[11px] text-[#d7b779] mb-1.5">Associate Butler ・ Fee</span>
                  <span className="jba-display text-white text-[34px] sm:text-[40px] leading-none">48,000<span className="text-lg text-[#d7b779] ml-1.5">円</span></span>
                  <span className="block font-['Noto_Serif_JP',serif] text-xs text-white/60 mt-1.5">税込・送料込 ／ 資格の有効期限なし</span>
                </div>
                <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-1.5 flex-1 min-w-[260px]">
                  {['テキスト教材（約100ページ）', 'オンライン動画レッスン（1年間）', '実技練習用キット', '認定試験問題・解答用紙', '認定証・認定カード', '執事サロン3時間無料体験'].map((x) => (
                    <li key={x} className="flex items-start gap-2 font-['Noto_Serif_JP',serif] text-[13px] text-[#e7e2d8] leading-[1.7]">
                      <span className="text-[#d7b779] text-[11px] pt-1" aria-hidden="true">◆</span>{x}
                    </li>
                  ))}
                </ul>
              </div>
              <p className="font-['Noto_Serif_JP',serif] text-base text-[#e7e2d8] leading-[1.95] max-w-3xl mb-8">
                多忙なかたでも無理なく学べる通信教育です。執事の基礎を体系的に学び、品格ある所作を暮らしに取り入れてみませんか。ご不明な点は、お気軽にお問い合わせください。
              </p>
              <div className="flex flex-col sm:flex-row gap-4 sm:gap-6">
                <a href="/contact" className={BTN08_ON_NAVY}>受講を申し込む・相談する</a>
                <a href="/qualifications" className={BTN08_ON_NAVY}>資格制度の一覧に戻る</a>
              </div>
            </div>
            <p className="font-['Noto_Serif_JP',serif] text-xs text-[#8f7a56] leading-[1.9] mt-6 max-w-3xl">
              本資格は全日本執事協会が認定する民間資格です。資格取得により就職・転職・収入を保証するものではなく、知識習得と自己研鑽を目的とした学習プログラムです。実際の就業には各雇用先の採用基準に従ってください。
            </p>
          </section>

        </div>
      </div>
    </Layout>
  );
}
